export { default } from './deepmerge';
export * from './deepmerge';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/deepmerge/index.js
// module id = 51
// module chunks = 25